export default {
  props: {
    control: {
      required: true,
      type: Object,
    },
    handleValueChange: {
      required: true,
      type: Function,
    },
  },

  methods: {
    // eslint-disable-next-line consistent-return
    getTooltip() {
      const { tooltip } = this.control;

      if (tooltip && tooltip.variables && tooltip.variables.message) {
        return { text: tooltip.variables.message };
      }
    },

    handleChange(value) {
      this.handleValueChange(this.control.id, value);
    },

    handleInputChange(...args) {
      const handler = this.control.handleInputChange || this.handleChange;
      return handler(...args);
    },
  },
};
